import { Alert as MuiAlert, AlertTitle } from '@mui/material';
import PropTypes from 'prop-types';

import cm from '../../../utils/class-merge';

const AlertPropTypes = {
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  className: PropTypes.string,
  title: PropTypes.string,
  fontSize: PropTypes.number,
  icon: PropTypes.node,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func,
  ]),
};

const Alert = (props) => {
  const { type, className, title, children, fontSize, icon, ...rest } = props;
  const classNames = cm(
    className,
    'alert',
  );
  return (
    <MuiAlert color={type} icon={icon} className={classNames} {...rest}>
      <AlertTitle style={{ fontSize }}>{title}</AlertTitle>
      {children}
    </MuiAlert>
  );
};

Alert.propTypes = AlertPropTypes;

export default Alert;
